import RouteWrapper from "@/components/common/RouteWrapper.vue";
import RouteNames from "@/entities/RouteNames";
import NavigationIcons from "@/entities/NavigationIcons";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import Roles from "@/entities/Roles";

const Groups = () => import("@/views/manage/Groups.vue").then((m) => m.default);
const GroupDetails = () =>
  import("@/components/teams/GroupDetails.vue").then((m) => m.default);
const GroupDocuments = () =>
  import("@/components/teams/GroupDocuments.vue").then((m) => m.default);
const Team = () => import("@/views/manage/Group.vue").then((m) => m.default);

const getGroupsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/groups",
    component: RouteWrapper,
    meta: {
      title: "Teams",
      requiresAuth: true,
      breadcrumb: {
        title: BreadcrumbsTitles.GROUPS,
        icon: NavigationIcons.GROUPS,
        routeName: RouteNames.MANAGE_TEAMS,
        copyLink: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.MANAGE_TEAMS,
        component: Groups,
        meta: {
          title: "Groups",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getGroupPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "details",
    name: RouteNames.GROUP_DETAILS,
    component: GroupDetails,
    meta: {
      title: "Group Details",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "documents",
    name: RouteNames.GROUP_DOCUMENTS,
    component: GroupDocuments,
    meta: {
      title: "Group Documents",
      roles: [Roles.ADMIN, Roles.MANAGER],
    },
  },
]);

const getGroupPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    component: Team,
    props: true,
    meta: {
      title: "Team",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.GROUP_DETAILS,
        isStyled: true,
      },
    },
  },
]);

export {
  getGroupsRoutes,
  getGroupPrivatePageRoutes,
  getGroupPrivatePageTabsRoutes,
};
